import HeaderCity from './components/HeaderCity.vue';
import InitComponent from 'Modules/InitComponent';
import store from '../stores/store';

const headerCity = document.getElementById('header-city');
const initComponent = new InitComponent({
  selectors: headerCity,
  components: { HeaderCity },
  template: '<HeaderCity />',
  store,
});

initComponent.init();
